import { FC } from 'react';
import SingleProposalStyles from './SingleProposalStyles';
import Skeleton from 'react-loading-skeleton';

const SingleProposalSkeleton: FC = () => {
  return (
    <div className="pr-single">
      <SingleProposalStyles />
      <div id="pr-header">
        <div
          style={{
            padding: '5px 40px 10px',
            marginBottom: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            color: '#000',
          }}
          className="pr-header-content"
        >
          <div style={{ width: 160 }} className="pr-header-content-logo">
            <Skeleton height={38} width={160} />
          </div>
          <div style={{ fontWeight: 'bold', fontSize: 16 }} className="pr-header-content-title">
            <Skeleton height={20} width={150} />
          </div>
          <div
            className="pr-header-content-date"
            style={{
              fontSize: '12px',
              display: 'flex',
              position: 'relative',
            }}
          >
            <Skeleton height={16} width={180} />
            <div style={{ position: 'absolute', right: -45 }} className="pr-header-content-edit">
              <Skeleton height={32} width={32} borderRadius={5} />
            </div>
          </div>
        </div>
      </div>

      <div id="pr-body">
        <div className="pr-header-single pr-flex-between">
          <div style={{ width: '100%' }}>
            <Skeleton height={16} width="90%" style={{ marginBottom: 8 }} />
          </div>
        </div>

        <div className="pr-body-content">
          <div className="pr-hotel-card" style={{ marginBottom: 20 }}>
            <div className="pr-hotel-card-title">
              <Skeleton height={20} width={200} />
            </div>
            <div className="pr-hotel-content">
              <div className="pr-hotel-image-container">
                <Skeleton height={140} width="100%" />
              </div>
              <div className="pr-hotel-details" style={{ flex: 1 }}>
                <div className="pr-hotel-detail-row">
                  <Skeleton height={16} width={120} style={{ marginBottom: 7 }} />
                </div>
                <div className="pr-hotel-detail-row">
                  <Skeleton height={16} width={150} style={{ marginBottom: 7 }} />
                </div>
                <div className="pr-hotel-detail-row">
                  <Skeleton height={16} width={100} style={{ marginBottom: 7 }} />
                </div>
                <div className="pr-hotel-detail-row">
                  <Skeleton height={16} width={180} style={{ marginBottom: 7 }} />
                </div>
              </div>
            </div>
            <div className="pr-table-wr" style={{ marginTop: 15 }}>
              <table className="pr-table">
                <thead>
                  <tr>
                    <th>
                      <Skeleton height={14} width={80} />
                    </th>
                    <th>
                      <Skeleton height={14} width={100} />
                    </th>
                    <th>
                      <Skeleton height={14} width={80} />
                    </th>
                    <th>
                      <Skeleton height={14} width={100} />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2].map((row) => (
                    <tr key={row}>
                      <td>
                        <Skeleton height={14} width={60} />
                      </td>
                      <td>
                        <Skeleton height={14} width={90} />
                      </td>
                      <td>
                        <Skeleton height={14} width={70} />
                      </td>
                      <td>
                        <Skeleton height={14} width={80} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="pr-hotel-card" style={{ marginBottom: 20 }}>
            <div className="pr-hotel-card-title">
              <Skeleton height={20} width={180} />
            </div>
            <div style={{ padding: 15 }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 15 }}>
                <Skeleton height={53} width={80} style={{ marginRight: 15 }} />
                <div style={{ flex: 1 }}>
                  <Skeleton height={16} width={200} style={{ marginBottom: 8 }} />
                  <Skeleton height={14} width={150} />
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                <div>
                  <Skeleton height={14} width={120} style={{ marginBottom: 5 }} />
                  <Skeleton height={14} width={100} />
                </div>
                <div>
                  <Skeleton height={14} width={120} style={{ marginBottom: 5 }} />
                  <Skeleton height={14} width={100} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="pr-footer" style={{ position: 'relative', left: -30 }}>
        <div
          style={{
            marginTop: 20,
            color: '#333',
            marginInline: 30,
            backgroundColor: '#f3f4f5',
            padding: 10,
            border: '1px solid #ddd',
            borderRadius: 5,
            fontSize: 14,
            width: '100%',
          }}
        >
          <Skeleton height={16} width={250} />
        </div>
      </div>
    </div>
  );
};

export default SingleProposalSkeleton;
